import React from 'react';
import PropTypes from 'prop-types';
import CollectionsHeroBanner from './CollectionsHeroBanner';

const CollectionsHero = props => {
  const {
    collections = [],
    collectionsTitle,
    collectionsIntents = [],
    fptiClick,
    fptiImpression
  } = props;

  return (
    collections.length > 0 && (
      <section id="appcenter-collections-hero">
        <div className="collections-hero-container">
          <div className="collections-hero-grid">
            {collections.length < 1 || collectionsIntents.length < 1 ? (
              <CollectionsHeroBanner
                collection={collections[0]}
                collectionsTitle={collectionsTitle}
                fptiClick={fptiClick}
                fptiImpression={fptiImpression}
                isSingleton={false}
              />
            ) : (
              collectionsIntents
                .slice(0, collectionsIntents.length > 2 ? 3 : 1)
                .map((intent, i) => {
                  const collection = collections.filter(
                    c => c.collectionKey === intent.name
                  )[0];
                  return (
                    <CollectionsHeroBanner
                      key={i}
                      collection={collection}
                      collectionsTitle={collectionsTitle}
                      fptiClick={fptiClick}
                      fptiImpression={fptiImpression}
                      isSingleton={collectionsIntents.length <= 2}
                    />
                  );
                })
            )}
          </div>
        </div>
      </section>
    )
  );
};

CollectionsHero.propTypes = {
  collections: PropTypes.array,
  collectionsTitle: PropTypes.string,
  fptiClick: PropTypes.func,
  fptiImpression: PropTypes.func,
  collectionsIntents: PropTypes.array
};

export default CollectionsHero;
